var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row mb-5" },
    [
      _c("section-headline", { attrs: { msg: "Mein Markt" } }),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-4 mb-5 mb-lg-0" }, [
        _c(
          "ul",
          { staticClass: "list-group list-group-flush" },
          _vm._l(_vm.myOptions, function(item, key) {
            return _c("market-sidebar", {
              key: key,
              class: _vm.activeTab.value === key ? " active" : "",
              attrs: { icon: item.icon, itemKey: key, text: item.text },
              on: { click: _vm.changeTab }
            })
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c("market-content", { attrs: { activeTab: _vm.activeTab } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }